let equipmentSystemIdSeed = 0;

export const getNextEquipmentSystemId = () => {
  equipmentSystemIdSeed += 1;
  return `EQP-TMP-${Date.now()}-${equipmentSystemIdSeed}`;
};

export const equipmentTypeOptions = [
  { label: "Bowser", value: "Bowser" },
  { label: "Tanker", value: "Tanker" },
  { label: "Container", value: "Container" },
  { label: "Trailer", value: "Trailer" },
  { label: "Other", value: "Other" },
];

export const capacityUnitOptions = [
  { label: "L", value: "L" },
  { label: "Tons", value: "Tons" },
  { label: "Units", value: "Units" },
];

export const brakeSystemOptions = [
  { label: "Air Brake", value: "air_brake" },
  { label: "Hydraulic Brake", value: "hydraulic_brake" },
  { label: "Electric Brake", value: "electric_brake" },
  { label: "Air Over Hydraulic", value: "air_over_hydraulic" },
  { label: "No Brake", value: "no_brake" },
];

export const suspensionTypeOptions = [
  { label: "Leaf Spring", value: "leaf_spring" },
  { label: "Air Suspension", value: "air_suspension" },
  { label: "Mechanical Suspension", value: "mechanical_suspension" },
  { label: "Rubber Suspension", value: "rubber_suspension" },
  { label: "Torsion Suspension", value: "torsion_suspension" },
];

export const containerSizeOptions = [
  { label: "10 ft", value: "10ft" },
  { label: "20 ft", value: "20ft" },
  { label: "40 ft", value: "40ft" },
  { label: "40 ft High Cube", value: "40ft_hc" },
  { label: "45 ft High Cube", value: "45ft_hc" },
];

export const usageMeterTypeOptions = [
  { label: "Kilometers", value: "kilometers" },
  { label: "Hours", value: "hours" },
  { label: "Cycles", value: "cycles" },
];

export const branchOptions = [
  { label: "Karachi", value: "Karachi" },
  { label: "Lahore", value: "Lahore" },
  { label: "Islamabad", value: "Islamabad" },
  { label: "Rawalpindi", value: "Rawalpindi" },
  { label: "Faisalabad", value: "Faisalabad" },
  { label: "Multan", value: "Multan" },
  { label: "Gujranwala", value: "Gujranwala" },
  { label: "Peshawar", value: "Peshawar" },
];

export const equipmentStatusOptions = [
  { label: "Active", value: "active" },
  { label: "Under Maintenance", value: "under_maintenance" },
  { label: "Inactive", value: "inactive" },
  { label: "Decommissioned", value: "decommissioned" },
];

export const paymentTypeOptions = [
  { label: "Full Payment", value: "full_payment" },
  { label: "Lease", value: "lease" },
  { label: "Financing", value: "financing" },
];

export const paymentMethodOptions = [
  { label: "Installments", value: "installments" },
  { label: "Bank Transfer", value: "bank_transfer" },
  { label: "Cheque", value: "cheque" },
  { label: "Cash", value: "cash" },
];

export const vendorOptions = [
  { label: "AutoHub Motors", value: "AutoHub Motors" },
  { label: "Fleet Prime", value: "Fleet Prime" },
  { label: "RoadLine Traders", value: "RoadLine Traders" },
  { label: "National Vehicles", value: "National Vehicles" },
];

export const depreciationMethodOptions = [
  { label: "Straight Line", value: "straight_line" },
  { label: "Declining Balance", value: "declining_balance" },
  { label: "Units of Production", value: "units_of_production" },
];

export const installmentFrequencyOptions = [
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
];

export const insuranceProviderOptions = [
  { label: "Adamjee Insurance", value: "adamjee_insurance" },
  { label: "EFU General Insurance", value: "efu_general" },
  { label: "Jubilee General Insurance", value: "jubilee_general" },
  { label: "State Life Insurance", value: "state_life" },
  { label: "TPL Insurance", value: "tpl_insurance" },
  { label: "IGI Insurance", value: "igi_insurance" },
  { label: "Pak Qatar General Takaful", value: "pak_qatar_takaful" },
  { label: "Alfalah Insurance", value: "alfalah_insurance" },
  { label: "Askari General Insurance", value: "askari_general" },
  { label: "UBL Insurers", value: "ubl_insurers" },
];

export const coverageTypeOptions = [
  { label: "Comprehensive", value: "comprehensive" },
  { label: "Third Party", value: "third_party" },
  { label: "Theft & Fire", value: "theft_fire" },
];
